var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    {
      staticClass: "cw-block-export-options",
    },
    [
      _c("header", [_c("translate", [_vm._v("Export Optionen")])], 1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-block-features-content",
        },
        [
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function click($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("translate", [_vm._v("Schließen")])],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }